import app from 'flarum/forum/app';
import IndexPage from 'flarum/forum/components/IndexPage';

import GroupRequest from '../common/models/GroupRequest';
import MeetupRequest from '../common/models/MeetupRequest';
import GroupRequestNotification from './components/GroupRequestNotification';
import MeetupRequestNotification from './components/MeetupRequestNotification';
import EncuentroPage from './components/EncuentroPage';
import EncuentrosPage from './components/EncuentrosPage';
import N8nChilePage from './components/N8nChilePage';
import ProponerPage from './components/ProponerPage';
import InvitacionPage from './components/InvitacionPage';
import RecursosPage from './components/RecursosPage';
import RegistroPage from './components/RegistroPage';
import SolicitudPage from './components/SolicitudPage';
import { ConvivenciaPage, PrivacidadPage } from './components/LegalPage';
import addHeaderNav from './addHeaderNav';
import addCategoryCounts from './addCategoryCounts';
import addEditorPreview from './addEditorPreview';
import addInterestButton from './addInterestButton';
import addN8nCard from './addN8nCard';
import addLoginPasswordReveal from './addLoginPasswordReveal';
import addLoginReturn from './addLoginReturn';
import guardMeetupsFeed from './guardMeetupsFeed';
import addPasswordSettings from './addPasswordSettings';
import addInvitarPanel from './addInvitarPanel';
import addProposeCta from './addProposeCta';
import addRegisterLink from './addRegisterLink';
import collapsibleSidebar from './collapsibleSidebar';
import headerHeight from './headerHeight';
import homeRouteClass from './homeRouteClass';
import hideLocaleSwitcher from './hideLocaleSwitcher';
import retargetLandingLinks from './retargetLandingLinks';
import themeToggle from './themeToggle';
import showActivationToast from './showActivationToast';
import showInviteAutograntToast from './showInviteAutograntToast';

app.initializers.add('umbral/comunidad', () => {
  // Los nombres de ruta tienen que coincidir con los del `Extend\Frontend(...)->route()` de
  // extend.php: el servidor rinde el HTML inicial y `app.route('<nombre>')` genera los
  // enlaces del SPA. Si divergen, el enlace apunta a una ruta que el cliente no conoce.
  app.routes['umbral-comunidad.n8nChile'] = { path: '/n8n-chile', component: N8nChilePage };

  // Feed limpio, sin la landing (`#cm-home` solo se muestra cuando el pathname es `/`).
  // No se puede reutilizar `/all`: `ForumApplication.mount()` reasigna a `/` la ruta cuyo
  // `path` sea igual a `default_route` (=/all), con lo que `/all` deja de existir en el SPA.
  app.routes['umbral-comunidad.discussions'] = { path: '/discusiones', component: IndexPage };

  // Form A (M2). Alta unica: identidad + acceso + perfil en un solo envio.
  app.routes['umbral-comunidad.registro'] = { path: '/registro', component: RegistroPage };

  // Form B (M3) + estados M4/M4c. Solo con sesion; el propio componente decide que estado
  // pintar segun `umbralComunidadGate` (ver `utils/requestForm`).
  app.routes['umbral-comunidad.solicitud'] = { path: '/n8n-chile/solicitar', component: SolicitudPage };

  // M6 (T11) — proponer un encuentro. Ruta propia, no la categoria Encuentros.
  app.routes['umbral-comunidad.proponer'] = { path: '/proponer-encuentro', component: ProponerPage };

  // PKG-ENCUENTROS-GALERIA — D6/D6b. El archivo publico de encuentros PASADOS, que no es la
  // cola de propuestas (`/proponer-encuentro`) ni la categoria de hilos (`/t/encuentros`). Ver
  // la nota larga de `extend.php` sobre las cuatro cosas que aqui se llaman «encuentro».
  app.routes['umbral-comunidad.encuentros'] = { path: '/encuentros', component: EncuentrosPage };
  app.routes['umbral-comunidad.encuentro'] = { path: '/encuentros/:slug', component: EncuentroPage };

  // A7 (T11) — las dos paginas del pie. Sin estas dos lineas el HTML server-side se veria un
  // instante y Mithril lo reemplazaria por «pagina no encontrada» al montar (mismo motivo por
  // el que existe `N8nChilePage`).
  app.routes['umbral-comunidad.convivencia'] = { path: '/convivencia', component: ConvivenciaPage };
  app.routes['umbral-comunidad.privacidad'] = { path: '/privacidad', component: PrivacidadPage };

  // T12 (objetivo 8) — hub de recursos. Sustituye a `/t/recursos` como destino de la tarjeta
  // de la landing y del sidebar: la categoria existe pero su feed esta vacio, y una tarjeta
  // que promete «guias completas» y abre una lista en blanco es peor que no estar.
  app.routes['umbral-comunidad.recursos'] = { path: '/recursos', component: RecursosPage };

  // T12B (objetivo 3) — el bearer llega en el fragmento, nunca en el path que ve el servidor.
  app.routes['umbral-comunidad.invitacion'] = { path: '/invitacion', component: InvitacionPage };
  // Sólo para enlaces ya emitidos antes del hardening; ninguna creación nueva usa este path.
  app.routes['umbral-comunidad.invitacion.legacy'] = { path: '/invitacion/:token', component: InvitacionPage };

  // El modelo del recurso tiene que estar ANTES de que llegue cualquier payload que lo
  // incluya: `Store.pushObject` descarta los tipos que no conoce, y la notificacion de la
  // campanita trae la solicitud como `subject`.
  app.store.models['umbral-group-requests'] = GroupRequest;
  app.notificationComponents.umbralGroupRequestDecided = GroupRequestNotification;
  app.notificationComponents.umbralGroupRequestObserved = GroupRequestNotification;

  // T-FORO-V14 — solicitudes privadas de encuentro. Mismo motivo que el par de arriba: el tipo
  // tiene que existir ANTES de que llegue el `subject` de la notificacion de admin.
  app.store.models['umbral-meetup-requests'] = MeetupRequest;
  app.notificationComponents.umbralMeetupRequestSubmitted = MeetupRequestNotification;

  // El POST del enlace confirma, inicia sesion y redirige aqui. El payload trae una marca
  // flash que solo existe en esa primera carga; mostrarla antes de montar el resto conserva
  // el resultado aunque la ruta de inicio cambie.
  showActivationToast();

  // Y, si esa misma confirmacion remato una invitacion pendiente, como acabo. Va detras porque
  // primero se cuenta que la cuenta quedo activa y despues que ademas ya esta dentro del grupo.
  showInviteAutograntToast();

  // Antes que nada lo que gobierna QUE se ve en `/`: la clase de ruta decide a la vez que
  // aparezca la landing y que no aparezca el feed (less/forum.less §4 y §4c).
  homeRouteClass();

  addHeaderNav();
  // Despues de `addHeaderNav`: mide el header YA con nuestro nav dentro, que es justo lo que
  // lo parte en dos filas en la franja de `less/forum.less` §3d-bis. El orden no es critico
  // (mide en el `oncreate` del header, no ahora), pero leerlo seguido cuenta la historia.
  headerHeight();
  addRegisterLink();
  // Configuración → «Cambiar contraseña» abre el modal de cambio real, no el correo del core.
  // No depende de rutas ni del orden de los otros `add*`: solo extiende `SettingsPage`.
  addPasswordSettings();
  // Y la misma revelación en «Acceder»: era la única contraseña del foro sin ojo.
  addLoginPasswordReveal();
  // PKG-FORO-N8N-DOWNLOAD-TRACKER — abre «Acceder» al llegar con `?acceder=1` y honra el
  // `return` (solo paths del propio foro) al entrar: la vuelta de `/descargas/{slug}`.
  addLoginReturn();
  // PKG-FORO-PRODUCT-GATES · B — la mitad de cliente del muro de `/t/encuentros`. Va JUNTO a
  // `addLoginReturn` porque son las dos caras del mismo viaje: este saca al invitado del feed y
  // aquel lo devuelve tras entrar. Ver `guardMeetupsFeed` para por que el middleware del
  // servidor no basta (la navegacion del SPA nunca llega a PHP).
  guardMeetupsFeed();
  // T-FORO-V14 (4) — vista previa del editor. Independiente del resto: no depende de rutas ni
  // del orden de los otros `add*`, sólo extiende `TextEditor`, común a los tres composers.
  addEditorPreview();
  collapsibleSidebar();
  addCategoryCounts();
  // T10 (10): antes de `addN8nCard` no importa, pero SI tiene que quedar registrado junto al
  // resto para que su `extend` sobre IndexPage.oncreate corra en la misma pasada.
  retargetLandingLinks();
  // T10 (5): el desplegable de idioma lo agrega el CORE dentro del propio `items()`, asi que
  // cualquier extender posterior lo ve — no necesita prioridad especial.
  hideLocaleSwitcher();
  // Despues de `collapsibleSidebar`: aquel baja la prioridad de `nav` a -10 y la n8card entra
  // a -20 para caer debajo de la lista de categorias. La tarjeta de M6 entra en medio (-15) y
  // solo dentro de la categoria de n8n Chile, y solo para quien tiene acceso
  // (PKG-FORO-PRODUCT-GATES · C: proponer sale de la comunidad abierta).
  addProposeCta();
  // El panel de invitar, TAMBIÉN en la categoría: quien ya es miembro aterriza en /t/n8n-chile
  // (destino de PKG-FORO-N8N-MEMBER-DESTINO) y ahí no había forma de generar una invitación.
  addInvitarPanel();
  addN8nCard();
});

/**
 * T10 (1) · Iniciador APARTE y con prioridad negativa, a proposito.
 *
 * `themeToggle` REEMPLAZA un item que pone `fof/nightmode` desde SU initializer. Los
 * extenders corren en el orden en que se registraron, asi que el nuestro tiene que
 * registrarse despues del suyo. `Application.boot()` recorre `initializers.toArray()`, que
 * ordena por prioridad DESCENDENTE (`ItemList`), y `fof/nightmode` usa la de por defecto (0):
 * con -100 el nuestro va ultimo pase lo que pase con el orden de carga de los bundles.
 *
 * Va en su propio initializer y no dentro del de arriba porque la prioridad se declara por
 * initializer, no por llamada.
 */
app.initializers.add('umbral/comunidad-theme', () => themeToggle(), -100);

/**
 * T12B (objetivo 9) · D8 — TAMBIEN aparte y con prioridad negativa, y por la MISMA razon.
 *
 * `addInterestButton` retira el boton «me gusta» que `flarum/likes` anade a `actionItems`. Los
 * extenders corren en el orden en que se registraron, asi que si el nuestro va primero
 * encuentra la lista sin ese item, no tiene nada que quitar, y `flarum/likes` lo anade despues:
 * quedan los DOS controles sumando al mismo contador.
 *
 * Se escribio primero dentro del initializer normal —con un comentario que afirmaba que «el
 * orden es indiferente»— y el caso de la suite lo desmintio: `nativeLike: true` con la tarjeta
 * D8 ya pintada al lado. Con -100 el nuestro va el ultimo pase lo que pase con el orden de
 * carga de los bundles, igual que `themeToggle`.
 */
app.initializers.add('umbral/comunidad-interest', () => addInterestButton(), -100);
